import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5001/api',
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('adminToken');
  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle token expiration
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('adminToken');
      const currentPath = window.location.pathname + window.location.search;
      const onAdminRoute = currentPath.startsWith('/admin') && !currentPath.startsWith('/admin/login');
      if (onAdminRoute) {
        // Stash the intended destination so the login page can bounce the user
        // back after re-auth. sessionStorage survives the hard nav below.
        try { sessionStorage.setItem('adminPostLoginReturn', currentPath); } catch {}
        window.location.replace('/admin/login');
      }
    }
    return Promise.reject(error);
  }
);

export default api;
